import React from "react";
import "../css/about.scss";

function About() {
  const journalPosts = [
    {
      id: 1,
      title: "Behind the scenes in our studio",
      image: "/generated/editorial/9.png",
    },
    {
      id: 2,
      title: "Prototyping a new notebook",
      image: "/generated/editorial/10.png",
    },
    {
      id: 3,
      title: "Designing our notebook collection",
      image: "/generated/editorial/11.png",
    },
    {
      id: 4,
      title: "Designing our Everyday Pen",
      image: "/generated/editorial/12.png",
    },
  ];

  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-background">
          <img src="/generated/editorial/about-hero.png" alt="pittleforestandco stationery studio" />
        </div>
        <div className="hero-content">
          <div className="hero-text-box">
            <h1>About pittleforestandco</h1>
            <p>
              pittleforestandco is a home for thoughtful stationery and paper
              goods: practical tools made to help ideas take root. Our
              collection brings together original notebooks, planners, pens
              and desk accessories chosen for everyday creativity.
            </p>
          </div>
        </div>
      </section>

      {/* Origins Section */}
      <section className="origins">
        <div className="origins-grid">
          <div className="origins-image">
            <img src="/generated/editorial/about-maker.png" alt="Notebook maker at work" />
          </div>
          <div className="origins-content">
            <h2>The origins of pittleforestandco</h2>
            <p>
              pittleforestandco began with a simple belief: the objects we use
              to capture ideas should feel considered, useful and quietly
              inspiring. What started as a small stationery project grew into a
              collection shaped by paper, colour and the natural world.
            </p>
            <p>
              Today, we focus on well-made essentials with tactile materials,
              calm palettes and flexible layouts. Each piece is selected to be
              a dependable companion for planning, writing and making, whether
              at a busy desk or out in the world.
            </p>
          </div>
        </div>
      </section>

      {/* Shop in Person Section */}
      <section className="shop-in-person">
        <div className="container">
          <h2>Shop our stationery in person</h2>
          <div className="shops-grid">
            <div className="shop-card">
              <img src="/generated/editorial/about-space-1.png" alt="Chelsea store" />
              <h3>Chelsea</h3>
              <p>170 Pavilion Road</p>
              <p>Chelsea, London</p>
              <p>SW1X 0AW</p>
            </div>
            <div className="shop-card">
              <img src="/generated/editorial/about-space-2.png" alt="Brighton store" />
              <h3>Brighton</h3>
              <p>21 Sydney St,</p>
              <p>Brighton, BN1 4EN</p>
            </div>
          </div>
        </div>
      </section>

      {/* Journal Section */}
      <section className="about-journal">
        <div className="container">
          <h2>Read more about pittleforestandco</h2>
          <div className="journal-grid">
            {journalPosts.map((post) => (
              <div key={post.id} className="journal-card">
                <div className="journal-image-wrapper">
                  <img src={post.image} alt={post.title} />
                </div>
                <h3>{post.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
